<label class="flex gap-3">
  <div class="flex h-6 shrink-0 items-center">
    <div class="grid-cols-1">
      <ng-content select="ui-checkbox" />
    </div>
  </div>
  <div class="text-sm/6">
    <ng-content />
  </div>
</label>
<div class="empty:hidden text-sm/6">
  <ng-content select="ui-input-error,[slot=bottom]" />
</div>
